import React from 'react';

export const zipCodeMask = (event: React.FormEvent<HTMLInputElement>) => {
  //00000-000
  event.currentTarget.maxLength = 9;
  let value = event.currentTarget.value;
  value = value.replace(/\D+/g, '').replace(/^(\d{5})(\d)/, '$1-$2');
  event.currentTarget.value = value;
  return event;
};

export const registeredNumberMask = (
  event: React.FormEvent<HTMLInputElement>
) => {
  //XX.XXX.XXX/0001.XX
  event.currentTarget.maxLength = 18;
  let value = event.currentTarget.value;
  value = value
    .replace(/\D+/g, '')
    .replace(/(\d{2})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1/$2')
    .replace(/(\d{4})(\d)/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1');
  event.currentTarget.value = value;
  return event;
};

export const phoneMask = (event: React.FormEvent<HTMLInputElement>) => {
  //(00)00000-0000
  event.currentTarget.maxLength = 15;
  let value = event.currentTarget.value;
  if (!value) return ""
  value = value.replace(/\D/g, "")
  value = value.replace(/(\d{2})(\d)/,"($1) $2")
  value = value.replace(/(\d)(\d{4})$/,"$1-$2")
  event.currentTarget.value = value;
  return value
};
